<bluesky-teaser>
  <a
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasScrolling"
  >
    <svg is='icon' name="message-circle" style="width: 18px" class="me-1"></svg>
    Latest News from the lab
  </a>
</bluesky-teaser>
